/**
 * Shared backend URL constants.
 *
 * ⚠️ POZOR — DVĚ KONSTANTY, ZÁMĚNA JE TYPICKÝ BUG:
 *   - `API`     = `${BACKEND_URL}/api`        ← BEZ /v1
 *   - `API_V1`  = `${BACKEND_URL}/api/v1`     ← SE /v1 (použij toto)
 *
 * Většina endpointů je versioned, takže defaultně použij API_V1.
 * Iter 224 bug "Chyba načítání: uživatelé" byl způsoben volání ${API}/users
 * (= /api/users → 404) místo ${API_V1}/users.
 *
 * Viz `config/api.d.ts` pro plnou typings dokumentaci.
 */
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Non-versioned API base. Použij JEN pro /api/health, /api/admin/*, atd. */
export const API = `${BACKEND_URL}/api`;

/** Versioned API base. Default volba pro většinu endpointů (/api/v1/*). */
export const API_V1 = `${BACKEND_URL}/api/v1`;
